import { Response } from '@models/performance/response.model';

export class ReviewResponse extends Response {
    protected static _resource = 'performanceManagement/reviews/:review/reviewResponses';
}
